import { ACUERDOS_PROXIMOS_KEY, AUTH_TOKEN, ENTERED_FROM_LOGIN, IS_FILIAL_SELECTED } from "constants/auth"
import { useNavigate } from "react-router-dom"

const useLogout = () => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.removeItem(AUTH_TOKEN)
    localStorage.removeItem(IS_FILIAL_SELECTED);
    localStorage.removeItem(ENTERED_FROM_LOGIN);
    sessionStorage.removeItem(ACUERDOS_PROXIMOS_KEY);
    navigate("/login")
  }
  return {
    logout
  }
}

export default useLogout